import { Field, Formik } from 'formik'
import { InitiateRefund, SentRefundOtp } from 'queries/actuals'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import NumberFormat from 'react-number-format'

import styled from 'styled-components'
import { Button } from 'ui/Buttons'
import Checkbox from 'ui/Checkbox'
import { Form, Input } from 'ui/forms'
import Loader from 'ui/Loader'
import { Modal } from 'ui/Modal'
import * as Yup from "yup"
import RefundSuccessModal from './RefundSuccessModal'
import { useGeneralSettings } from 'queries/generalSettings'
const StyledRfundForm = styled.div`
margin-top:20px;

`
const StyleRefundText = styled.h3`
    padding-left: 0;
    text-align: left;
    font-size: 26px;
    line-height: 29px;
    font-family: Montserrat Alternates-Bold;
    -webkit-letter-spacing: 0px;
    -moz-letter-spacing: 0px;
    -ms-letter-spacing: 0px;
    letter-spacing: 0px;
    color: #909090;
    background: none;
    outline: none;
    border: none;
    box-shadow: none;
    margin-bottom: 20px;
`
const StyledLabel = styled.span`
  text-align: left;
  font-family: Montserrat Alternates;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #909090;
  opacity: 1;
  margin-bottom: 8px;
  display: inline-block;
`;

const StyledRefundModal = styled.div`
      display: flex;
    justify-content: space-between;
    color: #909090;

    div{
        font-size: 18px;
    line-height: 36px;
    }
`

const StyledCheckboxDiv = styled.div`
margin:20px 0px;
input[type="checkbox"]{

margin-top:-8px;}

input[type="checkbox"]:checked:after{
font-size:16px;
}
label{
font-size:14px;
}

`


const StyledInput = styled.input`
width: 100%;
height: 40px;
padding: 10px;
background: #3a3b48 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 26px #00000017;
border: 1px solid #707070;
border-radius: 20px;
font-size: 14px;
line-height: 20px;
font-family: Montserrat Alternates;
letter-spacing: 0px;
color: #909090;

&:focus {    border: 1px solid #707070;
    outline: none;
    color: #3a3b48;
    background-color: #ffffff;}`
const RefundModal = ({ show, hide, data, refetch,handleSuccessModal }) => {

  const [isFullRefund, setFullRefund] = useState(false)
  const [loader, setLoader] = useState(false)
  const [optSent, setOptSent] = useState(false)
  const [error, setError] = useState(null)
  const initiateRefund = InitiateRefund()
  const [sentOtp, setSentOtp] = useState(null)
  const [actionDisabled, setActionDisabled] = useState(false)
  const [otp, setOtp] = useState(null)
  const [payload, setPayload] = useState(null)
  const refundOtp = SentRefundOtp()
    const { data: generalSettingsData, isLoading } = useGeneralSettings();
    
data.invoiceAmount = data?.invoiceAmount? data.invoiceAmount: data.TotalAmount
  if (typeof data.invoiceAmount === 'string') {
    data.invoiceAmount = parseFloat(data.invoiceAmount)
    data.remainingRefundAmount = data.invoiceAmount - data.refundAmount
  }else{
    data.remainingRefundAmount = data.invoiceAmount - data.refundAmount

  }
  const resetState = () => {
    setFullRefund(false)
    setActionDisabled(false)
    setSentOtp(null)
    setError(null)
    setOtp(null)
    setPayload(null)
    setOptSent(false)
    setLoader(false)
  }
  const formattedValue = (props = 0) => {
    const value = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(props)
    return value
  }
  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(null)
      }, 5000)
    }
  }, [error])

  const handleConfirm = () => {
  
    if (otp.length !== 4) {
      setError("Please enter a valid OTP");
      return;
    }
    setLoader(true)
    const finalpayload = {
      ...payload,
      otp: otp,
    }
    initiateRefund.mutate(finalpayload, {
      onSuccess: (res) => {
        if (res?.transactionDetails) {
          if (res.transactionDetails[0].transactionStatus === 'APPROVED' || res.transactionDetails[0].transactionStatus === 'PENDING') {
            resetState()
            refetch()
            setLoader(false)
            setFullRefund(false)
            handleSuccessModal(res,true)
            hide()

          }
          if (res.transactionDetails[0].transactionStatus === 'ERROR') {
            setTimeout(() => {
              setLoader(false)
              setError(res.transactionDetails[0].gwErrorReason)
            }, 2000)
          }
        }
        if (res?.message) {
          setError(res.message)
          setLoader(false)
        }
      },
      onError: (err) => {
        setLoader(false)
   
      },
    })

  }

  return (
<div className='modal-refund-payment-main'>
<Modal
      show={show}
      onHide={() => {
        hide()
        resetState()
      }}
      centered
      className="modal-refund-payment"
    >

     
      <StyleRefundText>
        Refund Payment
      </StyleRefundText>
      <>
        <StyledRefundModal>
          <div>
            Invoice Amount   <br />
            Previously Refunded <br />
            Available Amount
          </div>
          <div>
            :<br />
            : <br />
            :
          </div>
          <div style={{textAlign:'end'}}>
            {formattedValue(data.invoiceAmount)} <br />
            {formattedValue(data.refundAmount)} <br />
            {formattedValue(data.remainingRefundAmount)}
          </div>
        </StyledRefundModal>
        <hr />
        <StyledRfundForm>
          {data.remainingRefundAmount !==0 ?<>
            <Formik
            initialValues={{
              refundAmount: "",
              isFullRefund: false,
            }}
            onSubmit={(values, { setSubmitting }) => {
              setLoader(true)
              setSubmitting(true)
         

              const payload = {
                amount: isFullRefund ? data.remainingRefundAmount?.toFixed(2) : values.refundAmount,
                transactionId: data.transactionId,
              }

              const email =generalSettingsData?.destinationEmailAddress?.join(",")
            
              setPayload(payload)
                setError(`An OTP has been sent to the email address: ${email}`)
          
              // setSentOtp({ amount: payload.amount, actualAmount: data.invoiceAmount })
              refundOtp.mutateAsync({ amount: payload.amount, transactionId: data.transactionId,})
              setLoader(false)
              setOptSent(true)
              setActionDisabled(true)
              setSubmitting(false)
            }}
            validationSchema={Yup.object().shape({
              refundAmount: Yup.number()
              .max(data.remainingRefundAmount, `Amount cannot exceed ${formattedValue(data.remainingRefundAmount)}`)
              .test('is-full-refund', '', function (value) {
                if (isFullRefund) {
                return true; // Skip validation if isFullRefund is true
                }
              
                if(value < 1){

                  return this.createError({ message: 'Enter a valid amount' });
                }else{
                  return true
                }
              }),
            })}
            >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              setFieldValue
            }) => (
              <Form onSubmit={handleSubmit}>
                 {loader && <Loader displayCard={true} />}
                <>
                  {error && <div style={{ color: '#ff7171', fontSize: '12px', fontFamily: 'Montserrat Alternates-semiBold' }}>{error}</div>}
                  <StyledLabel>
                    Amount($)
                  </StyledLabel>
                  <Field
                    as={Input}
                    name="refundAmount"
                    type="text"
                    value={isFullRefund ? data.remainingRefundAmount?.toFixed(2) : values.refundAmount}
                    placeholder="Refund Amount"
                    disabled={isFullRefund || loader || actionDisabled}
                    onChange={(e) => {
                      isFullRefund ? setFieldValue('refundAmount', data.remainingRefundAmount.toFixed(2)) : setFieldValue('refundAmount', e.target.value)
                    }}
                  />
                  <StyledCheckboxDiv>
                    {!actionDisabled && <Checkbox
                      label={`Issue a full refund amount of ${formattedValue(data.remainingRefundAmount)}`}
                      name="isFullRefund"
                      type="checkbox"
                      value={isFullRefund}
                      disabled={actionDisabled}
                      onChange={(e) => {
                     
                        setFullRefund(!isFullRefund)
                      }}
                    />}
                  </StyledCheckboxDiv>
                  <div style={{ textAlign: 'end' }}>
                    {!actionDisabled && <Button
                      type="submit"
                      disabled={loader || actionDisabled || (!isFullRefund && (values.refundAmount === "" || !values.refundAmount || parseFloat(values.refundAmount) === 0))} 
                    >
                      Initiate Refund
                    </Button>}
                  </div>
                </>
              </Form>
            )}
          </Formik>
          {actionDisabled &&
            <>
              <StyledInput type="text" placeholder='OTP' onChange={(e) => setOtp(e.target.value)} />
              <div style={{ textAlign: 'end', marginTop: '20px' }}>
                <Button
                  onClick={handleConfirm}
                >
                  Confirm
                </Button>
              </div>
            </>}
          </> : <>
<p style={{ color: '#909090',fontSize:'16px',lineHeight:'30px'}}>This transaction has already been fully refunded. No remaining amount is available for refund.</p>
</>}
          
        </StyledRfundForm>
      </>
    </Modal>
</div>
  )
}

export default RefundModal